export const state = {

	getClientData : {},
	countriesList : {},
	citiesList : [],
	emailData : [],
	
	groupAdminName : {},
	userGroupId : {},
	//coupon
	couponList : [],
	sunPlanList : [],
	subExistList : [],
	subPlanDetail : [],
	
	//reporting
	reportingList : [],
	emirList : [],
	counterpartyList : [],
	
	//email
	emailList : [],
	
	//admin
	adminList : [],
	adminDetail : [],

	notificationList : [],
	notificationDetail:[],
	notificationListOld : [],
	notificationListUnread : [],

	//client
	catList : [],
	articleList : [],
	
	userList : [],
	userView : [],
	logsList : [],
	logsView : [],
	userCount : [],
	empStatus : {'01' : 'Employed','02' : 'Self-Employed','03' :'Unemployed','04' : 'Student' ,'05' :'Retired'},
	occupation :{'01' : 'Director','02' : 'Head/Manager of a Department','03' :'Partner','04' : 'Office Manager' ,'05' :'Admin/Secretarial' , '06' : 'Professional Staff', '07' : 'Accountant', '08' : 'Caretaker', '09' : 'Other'},
	estYearlyIncome : {'01' : '< 25k','02' : '25k - 50k','03' :'50k - 100k','04' : '100k - 250k' ,'05' :'250k - 500k','06' : '> 500k'},
	estNetWorth : {'01' : '< €25k ','02' : '€25k - €50k ','03' :'€50k - €100k ','04' : '€100k  - €250k ' ,'05' :'€250k  - €500k ','06' :'> €500k '},
	antAccountTurnover : {'01' : '€0 - €10k','02' :'€10k - €50k','03' :'€50k -€100k','04' :'€100k - €250k' ,'05' :'€250k - €500k','06' : '€500k +'},
	genderList : {'M' : 'male' , 'F' : 'female'},
	idenVerList : [{'key': '01' , 'value' : 'Face to Face Identification and Verification' }, {'key':'02' ,'value': 'Non Face to Face Identification and Verification = Original or Certified True Copies of  KYC'} ,  {'key' : '03' , 'value' : 'Non Face to Face Identification and Verification - Compliance with Section 2 of Fourth Appendix of Directive = Plain Copies of Originals'}, {'key' : '04', 'value' : 'Non Face to Face Identification and Verification - NOT in compliance with Section 2 of Fourth Appendix of Directive = Plain Copies of Originals'}, {'key' : '05', 'value' : 'No KYC provided/Failed to Verify Client/Client Unwilling to Provide'}],
	credInsList : [{'key' :'01' , 'value': 'EU/EEA Credit Institution (Regulated)' }, {'key' :'02' , 'value': 'EU/ EEA Financial Institution/Payment Institution (Regulated)'}, {'key' :'03' , 'value':  'EU/ EEA E-Wallet (Regulated)'},{'key' :'04' , 'value': 'EU/FATF - High Risk Country/Sanction List/Corruption List/Panama papers =Credit Institution/Financial Institution/Payment Institution/E-Wallet (Regulated & Unregulated)'},{'key' :'05' , 'value': 'Other 3rd Country Credit/Financial Institution/Payment Institution/E-Wallet  (Unregulated)'},{'key' :'06' , 'value':  'Other 3rd Country Credit/Financial Institution/Payment Institution/E-Wallet (Regulated)'}],
	thrdPartyList : [{'key' : '01' , 'value' : 'No such risk. The Company at all times requests for Power of Attorney stating the Authorised Representative(s) of the Account'}],
	
	
	
	fundSrcList : {'01' : 'Client' , '02' : 'Third Party','03' : 'Anonymous'},
	deptMethdList : {'01':'Credit Institution (Wire Transfer)','02' : 'Credit/Debit Card' , '03' : 'Financial Instritution/Payment Institution','04' : 'E-Wallet/Electronic Money','05' : 'Cash'},
	
	chnlRiskList : {'01' : 'Employee/Senior Management Recommendation/Meeting' , '02' : 'Introduction from existing client whose AML Risk is Low/Medium','03' : 'Intrdocution via Tied Agent, Affiliate, Introducer, Agent','04' : 'Online, no communication, own initiative'},
	
	stepList : {'0':'New Registeration','1':'Personal Information', '2':'Financial Details', '3':' Knowledge Experience', '4':'Declaration', '5':'Upload Personal Documents'},
	timeZone : {'Asia/Kolkata' : 'India' , 'Europe/Nicosia' : 'Cyprus' , 'Europe/London' : 'UK'},
	
	internalNotes : [],
	riskMetrix : [],

	//ticket
	ticketList : [],
	ticketView : [],
	ticketDocs : [],
	ticketData : [],
	ticketDocsLink : "https://app.fxview.com:2087/get/docs?type=",
	downloadUserZip : "https://admin.fxview.com:2087/get/zip?id=",
	withdrawalDocsLink : "https://admin.fxview.com:2087/get/docs?type=",
	reportDocLink :'https://admin.fxview.com:2087/get/report/zip?from=',
	ticketStatus: {'0' : 'open', '1' : 'doc verified', '2' : 'cancel', '3' : 'close'},
	ticketReason: {'1' : 'Document Upload' ,'2' :'Email Change' , '3' : 'Mobile Number Change'},
	ticketReasonList : [], 
	ticketReasonList1 : [], 
	department_list : [
		{'id' : '3','description' : 'Reporting Manager' , 'role' : 'RM'},
		{'id' : '4','description' : 'Back Office - Admin' , 'role' : 'BO-A'},
		{'id' : '5','description' : 'Back Office - Manager' , 'role' : 'BO-M'},
		{'id' : '6','description' : 'Back Office' , 'role' : 'BO'},
		{'id' : '7','description' : 'Accounts - Admin' , 'role' : 'AC-A'},
		{'id' : '8','description' : 'Accounts - Manager' , 'role' : 'AC-M'},
		{'id' : '9','description' : 'Accounts' , 'role' : 'AC'},
		{'id' : '10','description' : 'IT' , 'role' : 'IT'},
		{'id' : '11','description' : 'Customer Support' , 'role' : 'CS'},
		{'id' : '18','description' : 'Reporting Manager - Admin' , 'role' : 'RM-A'},
		{'id' : '19','description' : 'Reporting Manager - Manager' , 'role' : 'RM-M'},
		{'id' : '20','description' : 'RMS' , 'role' : 'RMS'},
		{'id' : '21','description' : 'RMS - Admin' , 'role' : 'RMS-A'},
		{'id' : '22','description' : 'RMS - Manager' , 'role' : 'RMS-M'},
	],  
	ticket_reply_pre : [
		{'name' : 'A', 'message' : 'please wait for reply'},{'name' : 'B', 'message' : 'ticket Reject'},
		{'name' : 'C', 'message' : 'please wait for rejection'},{'name' : 'D', 'message' : 'ticket approve'} 
	
	],
	
	//deposit
	depositList : [],
	depositView : [],
	depositStatus : {'-1' : 'Transaction Initiated', '0' : 'pending' ,'1' :'success', '2' :'Decilned','3':"Decilned", '4': "unverified account"},
	// depositMethod : {'1' : 'Bank' ,'2' :'Skrill', '3' : 'Neteller','4' : 'Trading Account', '5': 'Credit Card', '11': "NBP", '12':'TR', '13':'CR'},
	depositMethod : {'1' : 'Bank' ,'2' :'Skrill', '3' : 'Neteller','4' : 'Trading Account', '5': 'Credit Card', '6': 'Giropay', '7':'Przelewy', '8':'Rapid Transfer', '9':'Nordea', '10':'Klarna', '11': 'NBP', '12':'TR', '13':'CR'},
	
	//bonus
	bonusList : [],
	bonusView : [],
	
	//withdrawal
	withdrawalList : [],
	withdrawalListMaker : [],
	withdrawalView : [],
	withdrawalType : {'1' : 'Withdrawal' ,'2' :'Internal Transfer','3' :'Subscription'},
	withdrawalMethods : {'1' : 'bank_transfer.png' ,'2' :'skrill.png', '3' : 'neteller.png','5': 'CreditCard.svg', '6': "Giropay.svg", '7':"przelewy-24.svg", '8': "rapid-transfer.svg", '9': 'Nordea.svg', '10': 'Klarna.svg'},
	withdrawalMethod : {'1' : 'Bank' ,'2' :'Skrill', '3' : 'Neteller','4' : 'Trading Account', '5': 'Credit Card', '6': 'Giropay', '7':'Przelewy', '8':'Rapid Transfer', '9':'Nordea', '10':'Klarna', '11': 'NBP', '12':'TR', '13':'CR'}, //{'1' : 'bank transfer' ,'2' :'skrill', '3' : 'neteller','4' : 'Trading Account', '5': 'Credit Card', '11': "NBP", '12':'TR', '13':'CR'},
	withdrawalMethodResponse : [],
	withdrawalStatus : {'0' : 'pending', '1':'processed', '2':'rejected', '3':'rejected'}, 
	
	//trading
	tradingList : [],
	tradingView : [],
	demoLive : {'0' : 'demo' , '1' : 'live'},
	currency : {'EUR' : 'eur.svg','USD' : 'usd.svg','GBP' : 'gbp.svg','CHF' : 'chf.svg','JPY' : 'jpy.svg','AUD' : 'aud.svg'},
	/*leverage : {'01' : '100X' , '02' : '200X' , '03' : '300X'},
	currency : {'01':'USD','02':'GBP'},
	accountType : {'01' : 'ECN'},*/   //user later

	//bonus
	bonusType : {'1' : 'Add Bonus' ,'2' :'Remove Bonus'},
	bonusStatus : {'0' : 'open' , '1' : 'processed'},
	
	//permission
	permission : [],

	//tutorials
	tutorialList :[],

	//tradingeducation

	categoryList :[],
	postList: []
}


// WEBPACK FOOTER //
// ./src/plugins/fxView/provider/candle-history/store-addons/state.js